import { FILTER_KEYS } from "@/constants/constants";

export function filterActive(args) {
	const { filterKey, filterClasses } = args;
	const {
		filter_check_in_empty,
		filter_check_out_empty,
		filter_rout_city,
		filter_rout_state
	} = filterClasses || {};

	return (filterKey === FILTER_KEYS.CHECK_IN && filter_check_in_empty) ||
			(filterKey === FILTER_KEYS.CHECK_OUT && filter_check_out_empty) ||
			(filterKey === FILTER_KEYS.ROUTS && filter_rout_city) ||
			(filterKey === FILTER_KEYS.ROUTS && filter_rout_state);
}
